/* eslint-disable sort-keys */
export const lightBoxOverlay = {
    alignItems: 'center',
    backgroundColor: '$lightBoxOverlay',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    touchAction: 'none',
    zIndex: '$lightBox',
    variants: {isContainerWithHeader: {true: {paddingTop: '$$headerHeight'}}},
}

export const lightBoxImage = {
    borderRadius: 4,
    height: 'auto',
    objectFit: 'contain',
    transform: 'translate($$translateX, $$translateY) rotate($$rotate) scale($$zoom)',
    userSelect: 'none',
    willChange: 'transform',
}

export const lightBoxButtons = {
    'background': '$lightBoxHeader',
    'alignItems': 'center',
    'boxSizing': 'border-box',
    'padding': '5px',
    'width': '100%',
    '> div': {
        display: 'flex',
        justifyContent: 'space-between',
    },
}

export const imageWrapper = {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    overflow: 'hidden',
}

export const buttonsRight = {
    alignItems: 'center',
    display: 'flex',
    button: {fontWeight: 700},
}

export const lightBoxFooter = {
    alignItems: 'center',
    background: '$lightBoxHeaderBackground',
    color: '$lightBoxText',
    boxSizing: 'border-box',
    padding: '10px',
    width: '100%',
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
}

export const fileName = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
}

export const fileSize = {
    color: '$lightBoxFileSize',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '$lightBoxFileSize',
    minWidth: '50px',
}
